export const FLAVOUR_DETAIL_LIMITS = {
  whatsInsideItems: 6,
  whatsInsideItemLength: 120,
  ingredientsLength: 2400,
  allergenItems: 12,
  allergenItemLength: 80,
  minWeightG: 1,
  maxWeightG: 1000,
  galleryImages: 4,
} as const

export type FlavourDetailData = {
  whatsInside: string[]
  approxWeightG: number | null
  ingredients: string
  allergens: string[]
}

function normalizeWhitespace(value: string) {
  return value.replace(/\s+/g, ' ').trim()
}

export function normalizeDetailList(
  value: unknown,
  maxItems: number,
  maxItemLength: number,
): string[] | null {
  if (!Array.isArray(value) || value.length > maxItems) return null
  const result: string[] = []
  for (const item of value) {
    if (typeof item !== 'string') return null
    const normalized = normalizeWhitespace(item)
    if (!normalized || normalized.length > maxItemLength) return null
    if (!result.some((existing) => existing.toLowerCase() === normalized.toLowerCase())) result.push(normalized)
  }
  return result
}

export function normalizeWhatsInside(value: unknown) {
  return normalizeDetailList(
    value,
    FLAVOUR_DETAIL_LIMITS.whatsInsideItems,
    FLAVOUR_DETAIL_LIMITS.whatsInsideItemLength,
  )
}

export function normalizeAllergens(value: unknown) {
  return normalizeDetailList(
    value,
    FLAVOUR_DETAIL_LIMITS.allergenItems,
    FLAVOUR_DETAIL_LIMITS.allergenItemLength,
  )
}

export function normalizeIngredients(value: unknown) {
  if (typeof value !== 'string') return null
  const normalized = value.replace(/\s+/g, ' ').trim()
  return normalized.length <= FLAVOUR_DETAIL_LIMITS.ingredientsLength ? normalized : null
}

export function normalizeApproxWeightG(value: unknown): number | null | undefined {
  if (value === null || value === '') return null
  if (typeof value !== 'number' || !Number.isInteger(value)) return undefined
  if (value < FLAVOUR_DETAIL_LIMITS.minWeightG || value > FLAVOUR_DETAIL_LIMITS.maxWeightG) return undefined
  return value
}
